<app-status-badge
  [colourScheme]="colorScheme"
  [iconName]="iconName"
  [name]="name"
>
  {{ documentType }}
</app-status-badge>
